import Bloc from './Bloc.js';
import Types from './Types.js';
import Card from '../Card.js';

export default class ShuffleSupply extends Bloc {

	constructor (src, ctx) {

		super("shufflesupply", src, ctx, true);
		this.f = (src, ins, props) => {
			if (!ins[0])
				return;
			var gen;
			var n = ins[1] === null ? 1 : ins[1];
			var tier = ins.length < 3 || ins[2] === null ? 1 : ins[2];
			for (var i = 0; i < n && !src.master.deck.isFull; i++) {
				const model = tier > 1 ? Object.assign({}, ins[0], {tier}, ins[0].upgrades[tier-2]) : ins[0];
				if (!Card.canGenerate(src.master, model))
					continue;
				gen = new Card(src.master, model);
				src.master.supply.addCard(gen);
				src.master.notify("shufflecard", gen, src.master.supply);
				this.out = [gen];
				if (this["for each"])
					this["for each"].execute(props);
			}
			this.out = null;
			if (this.completed)
				this.completed.execute(props);
			return;
		};
		this.types = [Types.model, Types.int, Types.int];
		this.toPrepare.push("for each");
		this.toPrepare.push("completed");
	}
}
